import { Box, Checkbox, Divider, FormControlLabel, FormGroup, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';


function Tnc() {
      const location = useLocation();
      const [optional1, setOptional1] = useState<string | null>(null);
      const [optional2, setOptional2] = useState<string | null>(null);
      const [readTnc,setReadTnc] = useState<boolean>(false);
      // Parse query parameters
      const searchParams = new URLSearchParams(location.search);
      const minVal = searchParams.get('minVal');
      const maxVal = searchParams.get('maxVal');
      const optional1Param = searchParams.get('optional1'); // May or may not exist
      const optional2Param = searchParams.get('optional2');

      function handleCheck(){
            setReadTnc(!readTnc);
      }

  return (
<Box sx={{ padding: 3 }}>
<Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
<Typography variant="h4" gutterBottom>
                    Terms & Conditions for Benow Incentive Program
</Typography>
<Typography variant="body1" gutterBottom>
<ol>
<li>Benow Incentive Program is for Cashiers/Promoters who will be enrolled by selected Benow Registered Merchants.</li>
<li>This Program is for selected Merchants, and each Merchant can enroll only one cashier/promoter for their registered store.</li>
<li>Enrolled cashiers/promoters must complete their KYC and update their Bank account details to register for the Program.</li>
<li>Benow will conduct necessary due diligence, and if any suspicious activity is identified, necessary actions will be taken.</li>
<li>Program Duration: 1st Oct 2024 to 10th Nov 2024.</li>
<li>
                            Post successful registration, the Cashier/Promoter will be eligible to earn incentives as per the minimum threshold and maximum amount defined for them.
</li>
<li>
                            All Brand transactions done by the Merchant during the Program duration will be considered for incentive calculation as per the threshold and slab. Each unit sold will be incentivized based on the below Points table.
</li>
<li>Incentive Payout will be done within 1 month of completion of the offer period. Payout processing for eligible participants will be subject to completion of KYC initiated by Benow.</li>
<li>Payout will be subject to tax deductions if the payout crosses the threshold as per the Income Tax Act.</li>
<li>Refund/Failed transactions will be excluded from incentive calculation.</li>
<li>At any point during the term of this program, the program may be completely or partially revoked at the sole discretion of Benow. Benow is under no obligation to send prior notice regarding this.</li>

{(optional1Param && optional2Param) ? <>
      <li>
      For Mobile transactions, Minimum sale transaction count to qualify for incentive will be <strong>{minVal}</strong> and maximum incentives that can be
      earned will be Rs. <strong>{maxVal}</strong>.
      </li>
      <li>
      For Consumer Durable & IT sale (CDIT) transactions, Minimum sale transaction count to qualify for incentive will be <strong>{optional1Param}</strong> and maximum incentives that can be
      earned will be Rs. <strong>{optional2Param}</strong>.
      </li>
</>:  <>
<li>
                            Minimum transaction count to qualify for incentives will be <strong>{minVal}</strong> and the maximum incentives that can be earned will be Rs. <strong>{maxVal}</strong>.
                            Incentives for each sale would be as per the table below:
</li>
      </>
      }
</ol>
</Typography>
</Paper>
 
            <Divider sx={{ marginY: 3 }} />
 
            {/* Incentive Amount Table */}
<Typography variant="h6" gutterBottom>
                Incentive Amount (INR) on Each Sale
</Typography>
<TableContainer>
<Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', padding: '4px 8px' }}>Amount Range</TableCell>
            <TableCell sx={{ fontWeight: 'bold', padding: '4px 8px' }}>Incentive Amount (INR)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: '4px 8px' }}>Upto 9000</TableCell>
            <TableCell sx={{ padding: '4px 8px' }}>0</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ padding: '4px 8px' }}>9000 to &lt;25000</TableCell>
            <TableCell sx={{ padding: '4px 8px' }}>50</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ padding: '4px 8px' }}>25000 to &lt;40000</TableCell>
            <TableCell sx={{ padding: '4px 8px' }}>75</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ padding: '4px 8px' }}>40000 and above</TableCell>
            <TableCell sx={{ padding: '4px 8px' }}>100</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
</Box>

  )
}

export default Tnc